<template>
  <div id="general-search">
    <v-container fluid class="content-wrapper px-4 px-md-8">
      <v-tabs v-model="tab" show-arrows active-class="primary200--text">
        <v-tabs-slider color="primary200"></v-tabs-slider>
        <v-tab @click="goToGeneralSearch">{{ 'Services (' + resourcesLength + ')' }}</v-tab>
        <v-tab>{{ 'Providers (' + providersLength + ')' }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pa-6">
        <v-tab-item :transition="false" :reverse-transition="false" eager :key="1"> </v-tab-item>
        <v-tab-item :transition="false" :reverse-transition="false" eager :key="2">
          <marketplace-providers-component
            @providersLength="length => (providersLength = length)"
          ></marketplace-providers-component>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import MarketplaceProvidersComponent from '@/components/marketplace/MarketplaceProvidersComponet';
export default {
  name: 'MarketplaceGeneralSearchProvider',
  components: { MarketplaceProvidersComponent },
  data() {
    return {
      tab: 1,
      resourcesLength: '-',
      providersLength: '-',
      text: null,
    };
  },
  created() {
    this.text = this.$route.query.text;
    let url = '/api/v1/resources?';
    if (this.text) {
      url += '&text=' + this.text;
    }
    this.axios.get(url).then(res => {
      this.resourcesLength = res.data.total;
    });
  },
  methods: {
    goToGeneralSearch() {
      console.log('goToGeneralSearch');
      let path = 'MarketplaceGeneralSearch';
      if (!this.$router.currentRoute.meta.requiresAuth) {
        path = 'PublicMarketplaceGeneralSearch';
      }
      this.$router
        .push({
          name: path,
          query: { text: this.text },
        })
        .catch(err => {
          throw new Error(`Problem handling something: ${err}.`);
        });
    },
  },
};
</script>
